import { useEffect, useState } from 'react';
import type { AdornisUser } from '@adornis/users/db/a-user.js';
import { currentUser } from '@adornis/users/client/currentUser.js';

/**
 * React hook that subscribes to the Adornis `currentUser` observable.
 * Returns the currently logged-in user (or null/undefined when not logged in),
 * plus an `isLoading` flag that is true until the first value is emitted.
 */
export function useCurrentUser() {
  const [user, setUser] = useState<AdornisUser | null | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const subscription = currentUser().subscribe(value => {
      setUser(value ?? null);
      setIsLoading(false);
    });

    return () => subscription.unsubscribe();
  }, []);

  return { user, isLoading };
}
